// extracted by mini-css-extract-plugin
export var container = "_cd-0";
export var icon = "_cd-1";
export var text = "_cd-2";